var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 120 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M70.211 59.348v.129c0 5.64-4.576 10.202-10.205 10.202-5.63 0-10.206-4.575-10.206-10.202 0-5.628 4.576-10.203 10.206-10.203.28 0 .55 0 .82.035",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M88.504 48.818a30.046 30.046 0 0 1 1.93 10.647c0 16.801-13.634 30.42-30.428 30.42-16.795 0-30.43-13.63-30.43-30.42s13.624-30.42 30.43-30.42c4.47 0 8.719.96 12.534 2.703M66.045 8.559a50.705 50.705 0 0 1 19.99 6.739M9.06 53.44c2.762-23.494 21.406-42.12 44.907-44.881M53.955 110.396c-23.5-2.761-42.144-21.388-44.906-44.881M110.94 65.515c-2.762 23.493-21.394 42.12-44.895 44.881M105.837 36.451a50.668 50.668 0 0 1 5.091 16.907",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m60.006 59.477 29.364-27.46M89.803 42.044l-10.159-.924-.245-10.203 16.057-15.01.246 10.19 10.158.936-16.057 15.011Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M98.112 45.238c1.674 4.422 2.575 9.231 2.575 14.239 0 22.464-18.222 40.669-40.681 40.669-22.46 0-40.681-18.217-40.681-40.67 0-22.451 18.21-40.668 40.68-40.668 5.981 0 11.658 1.287 16.76 3.615",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M78.17 52.69a19.182 19.182 0 0 1 1.229 6.787c0 10.705-8.684 19.387-19.393 19.387-10.709 0-19.393-8.682-19.393-19.387 0-10.706 8.672-19.387 19.393-19.387 2.855 0 5.56.608 7.993 1.72",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.006 1v12.355M59.947 105.645V118M1.5 59.477h12.359M106.141 59.477H118.5",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTarget;